import React from 'react';
import { useState ,useEffect} from "react";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//  import SelectAll from '@ckeditor/ckeditor5-select-all/src/selectall';
function MyEditor({id,onChange}) {
  const [editorData, setEditorData] = useState('');
  
  
  const handleEditorChange = (event,editor) => {
    let data = editor.getData();
    setEditorData(data);
    onChange(id,data);
  };
  return (
    <div >
       <CKEditor
        editor={ClassicEditor}
        config={{
          toolbar: ['bulletedList', 'numberedList']
        }}
        data={editorData}
       onChange={handleEditorChange}
      />
    </div>
  );
}

export default MyEditor;
